const FormMessage = ({ message, type = 'info' }) => {
  const formMessageClass = `form-message form-message-${type}`;
  const formMessageContent= `form-message-content-${type}`

  return (
    <div className={formMessageClass}>
      <div className="form-message-icon">
        {type === 'info' && <span className="form-message-icon-circle">i</span>}
        {type === 'success' && <span className="form-message-icon-circle">✓</span>}
        {type === 'error' && <span className="form-message-icon-circle">✖</span>}
        {type === 'warning' && <span className="form-message-icon-circle">!</span>}
      </div>
      <div className={formMessageContent}>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default FormMessage;